export default function Logo() {
  return (
    <a href="#top" className="logo" data-testid="brand-logo" aria-label="Lunessa Spa Masaj ana sayfa">
      <img className="logo-mark" src="/emblem.png" alt="Lunessa Spa Masaj logosu" />
      <span className="logo-text">
        LUNESSA
        <small>Spa &amp; Masaj · Sivas</small>
      </span>
    </a>
  );
}
